function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import ActivityLogin from "./components/ActivityLogin/activity-login";
import { CloseCircleOutline } from 'antd-mobile-icons';
import setting from "./setting";
import CommonPool from "../../store/commonPool";
import { Payment } from "../../common";
import { getUserLoginInfo } from "../../service/userInfo";
import { SmButton } from "../..";
import { useEventPerform } from "../../hooks/useEventPerform";
import { sensorsTrack } from "../../service/sensors";
import qs from "../../utils/querystring";
var prefixCls = getPrefixCls('SmLogin');
// 需要将Ref共享到句柄池上时，需要使用forwardRef+useImperativeHandle将ref及需要暴露的属性共享出去
var Login = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params, _props$params2, _props$schema2, _props$schema2$params, _props$params3, _props$schema3, _props$schema3$params;
  var _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    _props$interactionLis = props.interactionListSchema,
    interactionListSchema = _props$interactionLis === void 0 ? [] : _props$interactionLis,
    productInfo = props.productInfo,
    openSetting = props.openSetting;
  var _ref = productInfo || {},
    singleProduct = _ref.product,
    activityDetail = _ref.activity,
    products = _ref.products,
    hasBuy = _ref.hasBuy,
    isTrial = _ref.isTrial;
  var product = useMemo(function () {
    return singleProduct || (products && (activityDetail !== null && activityDetail !== void 0 && activityDetail.channelDeliveryGroupId || products.length === 1) ? products[0] : null) || (isTrial ? products === null || products === void 0 ? void 0 : products[0] : null) || CommonPool.getSelectedProduct();
  }, [singleProduct, activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.channelDeliveryGroupId, products, isTrial, CommonPool.getSelectedProduct()]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    element = _useState4[0],
    setElement = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    userInfo = _useState6[0],
    setUserInfo = _useState6[1]; // 用户信息
  var _useState7 = useState(2),
    _useState8 = _slicedToArray(_useState7, 2),
    payType = _useState8[0],
    setPayType = _useState8[1]; // 支付方式
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    paymentVisible = _useState10[0],
    setPaymentVisible = _useState10[1]; // 支付弹窗
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loginStatus = _useState12[0],
    setLoginStatus = _useState12[1]; // 登录状态
  var refs = CommonPool.getRefs();
  var openModal = function openModal() {
    setVisible(true);
  };
  useImperativeHandle(ref, function () {
    return {
      openModal: openModal,
      chooseElement: chooseElement,
      modalClose: modalClose
    };
  });
  var getUserInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _isMounted, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _isMounted = true;
            _context.next = 3;
            return getUserLoginInfo();
          case 3:
            res = _context.sent;
            if (_isMounted) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            setUserInfo(res);
            return _context.abrupt("return", function () {
              _isMounted = false;
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getUserInfo() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    getUserInfo();
  }, [loginStatus]);
  var isPreview = (props === null || props === void 0 ? void 0 : props.componentRenderStatus) === 'preview';
  var params = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.params) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.params);
  var search = ((_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.search) || ((_props$schema2 = props.schema) === null || _props$schema2 === void 0 ? void 0 : (_props$schema2$params = _props$schema2.params) === null || _props$schema2$params === void 0 ? void 0 : _props$schema2$params.search);
  var source = ((_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : _props$params3.source) || ((_props$schema3 = props.schema) === null || _props$schema3 === void 0 ? void 0 : (_props$schema3$params = _props$schema3.params) === null || _props$schema3$params === void 0 ? void 0 : _props$schema3$params.source);
  var isEdit = source === 'development';
  var isDev = source === 'development' || (props === null || props === void 0 ? void 0 : props.componentRenderStatus) === 'preview';
  var hasChooseProduct = !!product;
  var _qs$parse = qs.parse(location.search),
    x_field_1 = _qs$parse.x_field_1;
  useEffect(function () {
    setVisible(open);
  }, [open]);
  var chooseElement = function chooseElement(tag) {
    setElement(tag || '');
  };
  useEffect(function () {
    if (visible && activityDetail) {
      sensorsTrack('SCRM_activitydetail_login_view', {
        scrm_activity_way: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.activityWay,
        scrm_activity_name: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.name,
        scrm_activity_id: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.id,
        scrm_product_name: product ? product.productName : '',
        scrm_plan_name: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.planName,
        scrm_plan_id: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.planId,
        scrm_xField: x_field_1 || ''
      });
    }
  }, [visible, activityDetail]);
  var _useEventPerform = useEventPerform(_objectSpread(_objectSpread({}, props), {}, {
      interactionListSchema: interactionListSchema,
      userInfo: userInfo,
      product: product,
      compsGuid: props.compsGuid || '',
      hasBuy: !!hasBuy,
      hasChooseProduct: hasChooseProduct,
      isDev: isDev,
      isPreview: isPreview,
      visible: paymentVisible,
      setVisible: setPaymentVisible,
      productInfo: productInfo,
      search: search,
      payType: payType,
      params: params
    })),
    eventQueue = _useEventPerform.eventQueue,
    removeEvent = _useEventPerform.removeEvent,
    initEvent = _useEventPerform.initEvent,
    handleEventStart = _useEventPerform.handleEventStart;
  var modalClose = function modalClose(type, status) {
    if (type === 'multiProductsModal') {
      switch (status) {
        case 'success':
          removeEvent();
          break;
        default:
          initEvent();
          break;
      }
    }
  };
  var oldLoginSuccess = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
      var _props$customFns, _props$customFns$init, _props$customFns2, _props$customFns2$onL;
      var hasConfirmAction, key, _refs$key2, _refs$key2$ref, _refs$key2$ref$curren, _refs$key2$ref$curren2, _refs$key2$ref$curren3, _refs$key, _refs$key$ref, _refs$key$ref$current, _refs$key$ref$current2, _refs$key$ref$current3;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            sensorsTrack('SCRM_activitydetail_login_click', {
              scrm_activity_way: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.activityWay,
              scrm_activity_name: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.name,
              scrm_activity_id: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.id,
              scrm_product_name: product ? product.productName : '',
              scrm_plan_name: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.planName,
              scrm_plan_id: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.planId,
              scrm_xField: x_field_1 || ''
            });
            setLoginStatus(true);
            setVisible(false);
            _context2.next = 5;
            return (_props$customFns = props.customFns) === null || _props$customFns === void 0 ? void 0 : (_props$customFns$init = _props$customFns.initProductInfo) === null || _props$customFns$init === void 0 ? void 0 : _props$customFns$init.call(_props$customFns);
          case 5:
            (_props$customFns2 = props.customFns) === null || _props$customFns2 === void 0 ? void 0 : (_props$customFns2$onL = _props$customFns2.onLoginSuccess) === null || _props$customFns2$onL === void 0 ? void 0 : _props$customFns2$onL.call(_props$customFns2, data);
            hasConfirmAction = interactionListSchema === null || interactionListSchema === void 0 ? void 0 : interactionListSchema.some(function (item) {
              return item.title === 'confirm';
            });
            for (key in refs) {
              if (Object.prototype.hasOwnProperty.call(refs, key)) {
                if (key === element) {
                  refs === null || refs === void 0 ? void 0 : (_refs$key = refs[key]) === null || _refs$key === void 0 ? void 0 : (_refs$key$ref = _refs$key.ref) === null || _refs$key$ref === void 0 ? void 0 : (_refs$key$ref$current = _refs$key$ref.current) === null || _refs$key$ref$current === void 0 ? void 0 : (_refs$key$ref$current2 = (_refs$key$ref$current3 = _refs$key$ref$current).loginSuccess) === null || _refs$key$ref$current2 === void 0 ? void 0 : _refs$key$ref$current2.call(_refs$key$ref$current3, hasConfirmAction && openSetting);
                }
                refs === null || refs === void 0 ? void 0 : (_refs$key2 = refs[key]) === null || _refs$key2 === void 0 ? void 0 : (_refs$key2$ref = _refs$key2.ref) === null || _refs$key2$ref === void 0 ? void 0 : (_refs$key2$ref$curren = _refs$key2$ref.current) === null || _refs$key2$ref$curren === void 0 ? void 0 : (_refs$key2$ref$curren2 = (_refs$key2$ref$curren3 = _refs$key2$ref$curren).loginSuccess) === null || _refs$key2$ref$curren2 === void 0 ? void 0 : _refs$key2$ref$curren2.call(_refs$key2$ref$curren3, true);
              }
            }
            setElement('');
            _context2.next = 11;
            return getUserInfo();
          case 11:
            if (openSetting) handleEventStart();
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function oldLoginSuccess(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    for (var key in refs) {
      var _refs$key3, _refs$key3$ref, _refs$key3$ref$curren, _refs$key3$ref$curren2, _refs$key3$ref$curren3;
      refs === null || refs === void 0 ? void 0 : (_refs$key3 = refs[key]) === null || _refs$key3 === void 0 ? void 0 : (_refs$key3$ref = _refs$key3.ref) === null || _refs$key3$ref === void 0 ? void 0 : (_refs$key3$ref$curren = _refs$key3$ref.current) === null || _refs$key3$ref$curren === void 0 ? void 0 : (_refs$key3$ref$curren2 = (_refs$key3$ref$curren3 = _refs$key3$ref$curren).initEvent) === null || _refs$key3$ref$curren2 === void 0 ? void 0 : _refs$key3$ref$curren2.call(_refs$key3$ref$curren3);
    }
    // refs?.[element]?.ref?.current?.initEvent?.();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-close")
  }, /*#__PURE__*/React.createElement(CloseCircleOutline, {
    fontSize: 24,
    color: "#fff",
    onClick: function onClick() {
      setVisible(false);
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  })), props.styleMode === 'modeB' && /*#__PURE__*/React.createElement("img", {
    src: "https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202304/18/ec6c4_20230418132341.png",
    alt: "",
    style: {
      width: '378px',
      verticalAlign: 'bottom'
    }
  }), /*#__PURE__*/React.createElement(ActivityLogin, _extends({
    activityDetail: activityDetail,
    onSuccess: oldLoginSuccess,
    loginBtnText: "\u767B\u5F55\u7EE7\u7EED\u8D2D\u4E70",
    style: props.styleMode === 'modeB' ? {
      borderRadius: '0 0 6px 6px'
    } : {}
  }, props)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-mask")
  })), isEdit && /*#__PURE__*/React.createElement("div", null, "\u767B\u5F55\u7EC4\u4EF6\u5360\u4F4D"), /*#__PURE__*/React.createElement(Payment, {
    productInfo: productInfo,
    visible: paymentVisible,
    setVisible: setPaymentVisible,
    payType: payType,
    setPayType: setPayType,
    isDev: isDev
  }, /*#__PURE__*/React.createElement(SmButton, _extends({}, props, {
    text: "\u7ACB\u5373\u652F\u4ED8",
    justPay: true,
    cusPayType: payType,
    devPay: isDev,
    style: {
      width: '100%'
    },
    productInfo: productInfo
  }))));
});
// ts定义在这里，使用时类型断言
var EnhancedLogin = EnhanceComponent(Login);
EnhancedLogin.settings = setting;
export default EnhancedLogin;